<template>
    <form @submit.prevent="handleSubmit">
        <div class="row">
            <div class="col-md">
                <Field label="Nom" name="last_name" v-model="registrant.last_name" :errors="errors" />
            </div>
            <div class="col-md">
                <Field label="Prénom" name="first_name" v-model="registrant.first_name" :errors="errors" />
            </div>
        </div>

        <Field label="Fonction" name="organization_position" v-model="registrant.organization_position" :errors="errors" />

        <div class="row">
            <div class="col-md-7">
                <Field label="Service" name="organization_service" v-model="registrant.organization_service" :errors="errors" />
            </div>
            <div class="col-md-5">
                <Field
                    label="Téléphone"
                    v-model="registrant.phone"
                    name="phone"
                    type="phone"
                    :errors="errors"
                />
            </div>
        </div>

        <div class="mt-3">

            <Field class="mb-2" name="email" v-model="registrant.email" :errors="errors">
                <template v-slot:label>
                    Adresse e-mail de l’inscrit <span class="font-weight-normal">(pour l’inviter à créer un compte)</span>
                </template>
            </Field>

            <div class="text-muted fs-7">
                Cette personne recevra un message à l’adresse indiquée l’invitant à créer un compte (pour lui permettre d’accéder directement aux informations liées à son inscription).<br>
                Si elle ne crée pas de compte, ces informations vous seront adressées pour transmission à l’inscrit.
            </div>
        </div>

        <slot name="footer" />
    </form>
</template>

<script>
    import { BFormCheckbox } from 'bootstrap-vue';
    import Field from "../../../Field";

    export default {
        components: {
            Field,
            BFormCheckbox,
        },
        props: {
            value: Object,
            errors: Object,
        },
        data() {
            return {
                registrant: {
                    ...this.value,
                },
            }
        },
        methods: {
            handleSubmit() {
                this.$emit('submit', this.registrant);
            },
        },
    }
</script>
